import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const AutocompleteSingle = ({ title, options, onChange, required, helperText, value, error }) => {

  const handleSelectionChange = (event, selectedOption) => {
    // Pass the value of the selected option (URL) to the parent
    onChange(selectedOption ? selectedOption.value : "");
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      value={value}
      onChange={handleSelectionChange}
      renderInput={(params) => <TextField {...params} label={title} required={required} helperText={helperText} variant="outlined"
      // error={error ? !!error : false}
      />}
    />
  );
};

export default AutocompleteSingle;
